if (!customElements.get('tpt-shop-the-look-4')) {
  class TptShopTheLook4 extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.handleWindowScroll = this.handleWindowScroll.bind(this);
    }

    connectedCallback() {
      this.scrollArea = this.querySelector('.tpt-shop-the-look_4_scroll-area');
      this.labels = this.querySelectorAll('.tpt-shop-the-look_4_label');
      this.sliders = this.querySelectorAll('.tpt-shop-the-look_4_slider');
      this.container = this.closest('.tpt-shop-the-look-4_container');
      
      // Check if mobile
      this.checkMobile();
      window.addEventListener('resize', () => this.checkMobile());
      
      this.initLabelClick();
      this.initScrollSync();
      this.initNavButtons();
    }

    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

    initLabelClick() {
      this.labels.forEach(label => {
        label.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // MOBILE: Click any label -> scroll to scroll area
          if (this.isMobile) {
            if (this.scrollArea) {
              const scrollOffset = this.scrollArea.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: scrollOffset - 20, // Small offset from top
                behavior: 'smooth'
              });
            }
            
            // Update active state
            this.labels.forEach(l => l.classList.remove('active'));
            label.classList.add('active');
            return;
          }
          
          const targetCardId = label.dataset.targetCard;
          const targetSlider = this.querySelector(`[data-card-id="${targetCardId}"]`);
          
          if (!targetSlider || !this.scrollArea) return;

          const scrollAreaRect = this.scrollArea.getBoundingClientRect();
          const cardRect = targetSlider.getBoundingClientRect();
          const scrollAreaCenter = scrollAreaRect.width / 2;
          const cardCenter = cardRect.width / 2;
          const cardLeft = targetSlider.offsetLeft;
          
          const targetScrollLeft = cardLeft - scrollAreaCenter + cardCenter;
          
          this.scrollArea.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
          });

          // Update active state
          setTimeout(() => {
            this.labels.forEach(l => l.classList.remove('active'));
            label.classList.add('active');
          }, 100);
        });
      });
    }

    initScrollSync() {
      // Mobile: No scroll sync needed (cards are in column layout)
      if (this.isMobile) {
        return;
      }
      
      // Fixed height mode: listen to scroll area
      if (!this.scrollArea) return;
      
      this.scrollArea.addEventListener('scroll', () => {
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.updateActiveLabelForScrollArea();
            this.ticking = false;
          });
          this.ticking = true;
        }
      });

      // Initial check
      this.updateActiveLabelForScrollArea();
    }

    initNavButtons() {
      const nextBtn = this.querySelector('.tpt-shop-the-look_4_next');
      const prevBtn = this.querySelector('.tpt-shop-the-look_4_prev');

      if (!nextBtn && !prevBtn) return;
      if (!this.scrollArea || !this.sliders.length) return;

      nextBtn?.addEventListener('click', () => this.scrollToNext());
      prevBtn?.addEventListener('click', () => this.scrollToPrev());
    }

    scrollToNext() {
      const scrollLeft = this.scrollArea.scrollLeft;
      const currentIndex = this.getNearestSliderIndex(scrollLeft);
      const nextIndex = Math.min(currentIndex + 1, this.sliders.length - 1);
      this.scrollToSlider(nextIndex);
    }

    scrollToPrev() {
      const scrollLeft = this.scrollArea.scrollLeft;
      const currentIndex = this.getNearestSliderIndex(scrollLeft);
      const prevIndex = Math.max(currentIndex - 1, 0);
      this.scrollToSlider(prevIndex);
    }

    getNearestSliderIndex(scrollLeft) {
      let minDiff = Infinity;
      let nearestIndex = 0;

      this.sliders.forEach((slider, index) => {
        const offset = slider.offsetLeft;
        const diff = Math.abs(offset - scrollLeft);
        if (diff < minDiff) {
          minDiff = diff;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    scrollToSlider(index) {
      const target = this.sliders[index];
      if (!target) return;

      const scrollAreaRect = this.scrollArea.getBoundingClientRect();
      const scrollAreaCenter = scrollAreaRect.width / 2;
      const targetRect = target.getBoundingClientRect();
      const targetCenter = target.offsetLeft + targetRect.width / 2;
      const targetScrollLeft = targetCenter - scrollAreaCenter;

      this.scrollArea.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });

      // Update active label
      this.setActiveLabel(target);
    }


    handleWindowScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateActiveLabelForWindow();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateActiveLabelForScrollArea() {
      if (!this.sliders || this.sliders.length === 0 || !this.scrollArea) return;

      const scrollAreaRect = this.scrollArea.getBoundingClientRect();
      const scrollAreaCenter = scrollAreaRect.left + scrollAreaRect.width / 2;

      let activeSlider = null;
      let minDistance = Infinity;

      this.sliders.forEach(slider => {
        const rect = slider.getBoundingClientRect();
        const sliderCenter = rect.left + rect.width / 2;
        const distance = Math.abs(sliderCenter - scrollAreaCenter);

        // Check if visible horizontally
        if (rect.left < scrollAreaRect.right && rect.right > scrollAreaRect.left) {
          if (distance < minDistance) {
            minDistance = distance;
            activeSlider = slider;
          }
        }
      });

      this.setActiveLabel(activeSlider);
    }


    updateActiveLabelForWindow() {
      if (!this.sliders || this.sliders.length === 0) return;

      const viewportCenter = window.innerHeight / 2;
      let activeSlider = null;
      let minDistance = Infinity;

      this.sliders.forEach(slider => {
        const rect = slider.getBoundingClientRect();
        const sliderCenter = rect.top + rect.height / 2;
        const distance = Math.abs(sliderCenter - viewportCenter);

        // Check if slider is visible in viewport
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          if (distance < minDistance) {
            minDistance = distance;
            activeSlider = slider;
          }
        }
      });

      this.setActiveLabel(activeSlider);
    }

    setActiveLabel(activeSlider) {
      if (activeSlider) {
        const cardId = activeSlider.dataset.cardId;
        
        this.labels.forEach(label => {
          if (label.dataset.targetCard === cardId) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.scrollArea) {
        this.scrollArea.removeEventListener('scroll', this.updateActiveLabelForScrollArea);
      }
    }
  }

  customElements.define('tpt-shop-the-look-4', TptShopTheLook4);
}